import { network } from 'services/network';

export const ENDPOINT = 'api/bo/getLogicCheckerCategoryResults';

export const getLogicCheckerCategoryResults = (params) => {
    return network.post(ENDPOINT, params).then((response) => {
        return response.data;
    });
};
